/*
 * File: ReferralContactInformation.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Renders referral contact information
 */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { List } from "@material-ui/core";
import UIListItem from "components/ui/UIListItem";
import ReferralPhoneNumbers from "./ReferralPhoneNumbers";

const styles = {
  root: {
    width: "100%"
  }
};

const ReferralContactInformation = React.memo(
  function ReferralContactInformation({ classes, referral }) {
    return (
      <List className={classes.root}>
        <UIListItem label="Company/Office" value={referral.company} />
        <UIListItem label="Address" value={referral.address} />
        <UIListItem label="City" value={referral.city} />
        <UIListItem label="State" value={referral.state} />
        <UIListItem label="Zip" value={referral.zip} />
        <UIListItem
          label="Website"
          value={<a href={referral.website}>{referral.website}</a>}
        />
        <UIListItem
          label="Electronic Transmit Direct Address"
          value={<a href={referral.directAddress}>{referral.directAddress}</a>}
        />
        <UIListItem
          label="Email"
          value={<a href={"mailto:" + referral.email}>{referral.email}</a>}
        />
        <ReferralPhoneNumbers referral={referral} />
      </List>
    );
  }
);

ReferralContactInformation.propTypes = {
  classes: PropTypes.object,
  referral: PropTypes.object
};

export default withStyles(styles)(ReferralContactInformation);
